import { FormProvider, useForm } from "react-hook-form";
import { defaultValues as defaultFormValues } from "./constants";
import { TowerPaymentsPairFormValues, schema } from "./types";
import { yupResolver } from "@hookform/resolvers/yup";

export interface TowerPaymentsPairFormProviderProps {
  children?: React.ReactNode;
  defaultValues?: Partial<TowerPaymentsPairFormValues>;
}

export const TowerPaymentsPairFormProvider = ({
  children,
  defaultValues,
}: TowerPaymentsPairFormProviderProps) => {
  const methods = useForm<TowerPaymentsPairFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: { ...defaultFormValues, ...defaultValues },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
